import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
	providedIn: 'root',
})
export class ImageService {
	constructor() {
	}

	public downscaleImage(file: File, maxWidth: number, maxHeight: number, quality = 0.8): Observable<Blob> {
		return new Observable<Blob>((observer) => {
			const img = new Image();
			const reader = new FileReader();

			reader.onerror = (error) => {
				observer.error(`FileReader failed: ${error}`);
			};

			img.onerror = () => {
				observer.error(`Invalid file format: Images must be of type jpeg or png.`);
			};

			reader.onload = e => {
				img.onload = () => {
					let { width, height } = img;

					// Calculate scale factor
					const scale = Math.min(maxWidth / width, maxHeight / height, 1);
					width = Math.round(width * scale);
					height = Math.round(height * scale);

					// Skip resizing if scale is 1
					if (scale === 1) {
						observer.next(file); // use original file
						observer.complete();
						return;
					}

					const canvas = document.createElement('canvas');
					canvas.width = width;
					canvas.height = height;
					const ctx = canvas.getContext('2d');
					if (!ctx) return observer.error('Could not create canvas context');

					ctx.drawImage(img, 0, 0, width, height);

					canvas.toBlob(
						blob => {
							if (!blob) return observer.error('Failed to create blob');
							observer.next(blob);
							observer.complete();
						},
						file.type || 'image/jpeg',
						quality,
					);
				};
				img.src = e.target?.result as string;
			};

			reader.readAsDataURL(file);
		})
	}
}